import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { URL_SERVICIOS_AWS } from '../../config/url.servicio'

@Injectable()
export class CallcenterProvider {

  constructor(public http: Http) {

  }

 async buscarEstadosGestion(companiasId: any,tipo:any,pagina:any=1,
  cantidadPaginar:any=1000000) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "buscarEstadosGestion",
         parameters : { companiasId,tipo,pagina,cantidadPaginar}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error al guardar la placa:', error);
   throw error;
 }
}


async buscarAccionesEstadosGestion(companiasId: any,estadosGestionId:any,clientesId:any,tipo:any='C',fecha:any='1900-01-01') {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "buscarAccionesEstadosGestion",
         parameters : { companiasId,estadosGestionId,clientesId,tipo,fecha}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error:', error);
   throw error;
 }
}

async actualizarAccionesEstadosGestionIndividual(companiasId: any,accionesEstadosGestionIndividualId:any,clientesId:any) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "actualizarAccionesEstadosGestionIndividual",
         parameters : { companiasId,accionesEstadosGestionIndividualId,clientesId}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error:', error);
   throw error;
 }
}


async actualizaraccionesEstadosGestionIndividualPorClienteIdComentario(companiasId: any,accionesEstadosGestionIndividualPorClienteId:any,comentario:any) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "actualizaraccionesEstadosGestionIndividualPorClienteIdComentario",
         parameters : { companiasId,accionesEstadosGestionIndividualPorClienteId,comentario}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error:', error);
   throw error;
 }
}


async actualizaraccionesEstadosGestionIndividualPorClienteIdDesceClientes(
  companiasId:any,clientesId:any
      ,tieneCupoAprobado:any,montoAprobadoFinal:any,descripcionCupoAprobado:any
) {
  try {
       let url_servicio = URL_SERVICIOS_AWS;
       let values = {
         name: "actualizaraccionesEstadosGestionIndividualPorClienteIdDesceClientes",
         parameters : { companiasId,clientesId,tieneCupoAprobado,montoAprobadoFinal: Number(montoAprobadoFinal),descripcionCupoNoAprobado:descripcionCupoAprobado}
       }
       let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
       let options = new RequestOptions({ headers: headers }) // Create a request option
       let response = await this.http.post(`${url_servicio}/procedure`, values, options).toPromise();
       return response
 } catch (error) {
   console.error('Error:', error);
   throw error;
 }
}


}



// WEBPACK FOOTER //
// ./src/providers/callcenter/callcenter.ts